import { Button, buttonColors, buttonSizes, buttonTypes, Spinner } from "@tutellus/tutellus-components"
import { useEthereum, useTransactions } from "../../../context"
import { truncateAddress } from "../../../js/string"
import { WalletModal } from "../../modules/WalletModal"
import { useState } from "react"

export const WalletModalButton = () => {
  const { wallet } = useEthereum()
  const {
    transactions: { pending: pendingTransactions },
  } = useTransactions()
  const walletFormatted = wallet.account ? truncateAddress(wallet.account) : ""
  const hasPendingTransactions = pendingTransactions.length > 0
  const iconWallet = wallet.connector?.icon
  const [showWalletModal, setShowWalletModal] = useState(false)
  const handleOpen = () => setShowWalletModal(true)
  const handleClose = () => setShowWalletModal(false)

  return (
    <>
      <Button
        type={buttonTypes.OUTLINE}
        size={buttonSizes.SMALL}
        color={buttonColors.SURFACE_INVERSE}
        iconLeft={hasPendingTransactions ? <Spinner size="m" /> : <img src={iconWallet} alt="Wallet icon" />}
        hideTextOnMobile
        onClick={handleOpen}
      >
        {walletFormatted}
      </Button>
      {showWalletModal && <WalletModal onClose={handleClose} />}
    </>
  )
}
